import { useState, useEffect } from 'react'
import Surveys from './Surveys'
import Excerpts from './Excerpts'
import ShowColumnButton from './ShowColumnButton'

let windowWidth = window.innerWidth

const initialSurveys = document.getElementById('initial-surveys')?.textContent
const initialExcerpts = document.getElementById('initial-excerpts')?.textContent

const surveysData = initialSurveys ? JSON.parse(initialSurveys) : false
const excerptsData = initialExcerpts ? JSON.parse(initialExcerpts) : false

const supportsTwoColumns = surveysData && excerptsData

const isInitialMobileSize = window.matchMedia('(max-width: 767px)').matches

function App() {
  const [isMobileSize, setIsMobileSize] = useState(isInitialMobileSize)
  const [surveysVisible, setSurveysVisible] = useState(true)
  const [excerptsVisible, setExcerptsVisible] = useState(supportsTwoColumns && !isInitialMobileSize)

  const containerClasses = surveysVisible && excerptsVisible ? 'grid grid-cols-2 gap-16' : ''
  const canHide = surveysVisible && excerptsVisible && !isMobileSize

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth != windowWidth) {
        windowWidth = window.innerWidth

        setIsMobileSize(window.matchMedia('(max-width: 767px)').matches)
      }
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [setIsMobileSize])

  const hideColumn = (column) => {
    if (column === 'surveys') {
      setSurveysVisible(false)
    }

    if (column === 'excerpts') {
      setExcerptsVisible(false)
    }
  }

  const showColumn = (column) => {
    if (column === 'surveys') {
      setSurveysVisible(true)

      if (isMobileSize) {
        setExcerptsVisible(false)
      }
    }

    if (column === 'excerpts') {
      setExcerptsVisible(true)

      if (isMobileSize) {
        setSurveysVisible(false)
      }
    }
  }

  return (
    <div>
      {supportsTwoColumns && (
        <div className="mb-8 text-right md:-mt-6">
          {!surveysVisible && <ShowColumnButton column="surveys" showColumn={showColumn} />}
          {!excerptsVisible && <ShowColumnButton column="excerpts" showColumn={showColumn} />}
        </div>
      )}
      <div className={`${containerClasses}`}>
        {surveysData && (
          <Surveys
            data={surveysData}
            isVisible={surveysVisible}
            supportsTwoColumns={supportsTwoColumns}
            hideColumn={hideColumn}
            canHide={canHide}
          />
        )}
        {excerptsData && (
          <Excerpts
            data={excerptsData}
            isVisible={excerptsVisible}
            supportsTwoColumns={supportsTwoColumns}
            hideColumn={hideColumn}
            canHide={canHide}
          />
        )}
      </div>
    </div>
  )
}

export default App
